import React, { useState } from 'react';
import axios from 'axios';
import { CiSquareRemove } from "react-icons/ci";


export default function FundDetails({config}) {
  const [selectedSchemes, setSelectedSchemes] = useState([]);
  const [openPanel, setOpenPanel] = useState('fund_overview');
  
  const [funds, setFunds] = useState([
    // {
    //   id: 16925,
    //   name: "Quant Small Cap Fund",
    //   logo: "https://www.hdfcfund.com/images/hdfc_logo.svg",
    //   url: "/mutual-funds/quant-small-cap-fund-direct-plan-growth/16925",
    //   investUrl: "/mutual-funds/investment-details/16925",
    //   rating: 5,
    //   category: "Small Cap",
    //   subCategory: "Equity",
    //   fundAge: "11 yrs 9 m",
    //   fundSize: "₹26,645 Crs",
    //   returns: {
    //     threeMonths: "0.52%",
    //     sixMonths: "14.68%",
    //     oneYear: "50.83%",
    //     threeYear: "28.53%",
    //     fiveYear: "50.39%",
    //   },
    //   riskMeasures: {
    //     standardDeviation: 17.15,
    //     sharpe: 1.37,
    //     beta: 0.93,
    //     sortino: 2,
    //     alpha: 5.74,
    //   },
    //   portfolio: {
    //     topSectors: [
    //       { name: "Services", value: "15.05%" },
    //       { name: "Healthcare", value: "14.92%" },
    //       { name: "Financial", value: "14.5%" },
    //     ],
    //     topHoldings: [
    //       { name: "Reliance Industries Ltd.", value: "9.63%" },
    //       { name: "JIO Financial Services Ltd.", value: "6.71%" },
    //     ],
    //   },
    // },
  ]);

  // const addFund = () => {
  //   if (funds.length < 4) {
  //     const newFund = {
  //       id: Math.floor((Math.random() * 100) + 1),
  //       name: "New Fund",
  //       logo: "https://www.hdfcfund.com/images/hdfc_logo.svg",
  //       url: "/mutual-funds/new-fund-direct-plan-growth/16926",
  //       investUrl: "/mutual-funds/investment-details/16926",
  //       rating: 4,
  //       category: "Large Cap",
  //       subCategory: "Equity",
  //       fundAge: "5 yrs 2 m",
  //       fundSize: "₹18,340 Crs",
  //       returns: {
  //         threeMonths: "1.12%",
  //         sixMonths: "8.24%",
  //         oneYear: "24.89%",
  //         threeYear: "17.67%",
  //         fiveYear: "34.23%",
  //       },
  //       riskMeasures: {
  //         standardDeviation: 14.82,
  //         sharpe: 1.18,
  //         beta: 0.87,
  //         sortino: 1.6,
  //         alpha: 4.31,
  //       },
  //       portfolio: {
  //         topSectors: [
  //           { name: "Technology", value: "18.35%" },
  //           { name: "Healthcare", value: "13.79%" },
  //           { name: "Financial", value: "12.5%" },
  //         ],
  //         topHoldings: [
  //           { name: "Infosys Ltd.", value: "7.32%" },
  //           { name: "Tata Consultancy Services Ltd.", value: "6.18%" },
  //         ],
  //       },
  //     };
  //     setFunds([...funds, newFund]);
  //   }
  // };
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  // Handle search input change and fetch fund suggestions
  const handleSearchChange = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.length > 2) {
      // Fetch fund suggestions
      let selectedCategoryItem = 'null';
      let apiUrl = `${config.PY_API_URL}v2/category/${encodeURIComponent(selectedCategoryItem)}/products?offset=0&limit=10&sort_by=sort_order&sort_order=desc&return_periods=3,5&search=${value}`;
      const response = await axios.get(apiUrl);
      setSuggestions(response.data.data.products);
    } else {
      setSuggestions([]);
    }
  };

  // Handle fund selection from suggestions and fetch fund details
  const handleFundSelect = async (fund) => {
    // setSearchTerm(fund.name);
    setSuggestions([]);
    const apiUrl = `${config.PY_API_URL}category/products/${encodeURIComponent(fund.product_code)}`;
    const response = await axios.get(apiUrl);
    setFunds([...funds, response.data.data]);
  };

  // Remove a fund from the comparison list
  const removeFund = (id) => {
    setFunds(funds.filter(fund => fund.product.id != id));
  };

  // Toggle display panel
  const togglePanel = (panelId) => {
    setOpenPanel(panelId);
  };

  return (
    <div className="mfExplore-body">
      <section className="mf-compare-header">
        <h1>Compare Mutual Funds</h1>
        <div className="mfcompare-search-box">
          <input
            type="text"
            placeholder="Add more schemes to compare"
            autoComplete="off"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {suggestions.length > 0 && (
            <ul className="suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleFundSelect(suggestion)}>
                  {suggestion.name}
                </li>
              ))}
            </ul>
          )}
        </div>
        {/* <button onClick={addFund} className="cta add-fund-cta">Add New Fund</button> */}
      </section>

      <div className="mf-compare-container">

        <div className="compare-content">
          <table className="compare-table">
            <thead>
              <tr>
                <th style={{width: '20%'}}>Criteria</th>
                {funds.map((fund, index) => (
                  <th key={index}>
                    <img src={fund.product?.icon} alt={fund.product?.name} width="44" height="44" />
                    {/* <div><a href={fund.url}>{fund.name}</a></div> */}
                    <div>
                      <a href={fund.product?.product_code}>{fund.product?.name}</a>
                      <span className='item-remove-btn' onClick={() => removeFund(fund.product.id)}>
                        <CiSquareRemove />
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            {/* <tbody>
                <>
                <tr>
                  <td>
                    <b>Fund Overview</b>
                  </td>
                </tr>
                  <tr>
                    <td>Rating</td>
                    {funds.map((fund, index) => <td key={index}>{fund.rating} Stars</td>)}
                  </tr>
                  <tr>
                    <td>Category / Sub-category</td>
                    {funds.map((fund, index) => (
                      <td key={index}>{fund.category}, {fund.subCategory}</td>
                    ))}
                  </tr>
                  <tr>
                    <td>Fund Age</td>
                    {funds.map((fund, index) => <td key={index}>{fund.fundAge}</td>)}
                  </tr>
                </>
                <>
                <tr>
                  <td>
                    <b>Returns</b>
                  </td>
                </tr>
                  <tr>
                    <td>3 Months</td>
                    {funds.map((fund, index) => <td key={index}>{fund.returns.threeMonths}</td>)}
                  </tr>
                  <tr>
                    <td>6 Months</td>
                    {funds.map((fund, index) => <td key={index}>{fund.returns.sixMonths}</td>)}
                  </tr>
                  <tr>
                    <td>1 Year</td>
                    {funds.map((fund, index) => <td key={index}>{fund.returns.oneYear}</td>)}
                  </tr>
                </>
                <>

                <tr>
                  <td>
                    <b>Risk Measure</b>
                  </td>
                </tr>
                  <tr>
                    <td>Standard Deviation</td>
                    {funds.map((fund, index) => <td key={index}>{fund.riskMeasures.standardDeviation}</td>)}
                  </tr>
                  <tr>
                    <td>Sharpe Ratio</td>
                    {funds.map((fund, index) => <td key={index}>{fund.riskMeasures.sharpe}</td>)}
                  </tr>
                  <tr>
                    <td>Beta</td>
                    {funds.map((fund, index) => <td key={index}>{fund.riskMeasures.beta}</td>)}
                  </tr>
                </>
                <>
                <tr>
                  <td>
                    <b>Portfolio</b>
                  </td>
                </tr>
                  <tr>
                    <td>Top Sectors</td>
                    {funds.map((fund, index) => (
                      <td key={index}>
                        {fund.portfolio.topSectors.map((sector, i) => (
                          <div key={i}>{sector.name} ({sector.value})</div>
                        ))}
                      </td>
                    ))}
                  </tr>
                  <tr>
                    <td>Top Holdings</td>
                    {funds.map((fund, index) => (
                      <td key={index}>
                        {fund.portfolio.topHoldings.map((holding, i) => (
                          <div key={i}>{holding.name} ({holding.value})</div>
                        ))}
                      </td>
                    ))}
                  </tr>
                </>
            </tbody> */}


            <tbody>
              <>
                <tr>
                  <td><b>Fund Overview</b></td>
                </tr>
                <tr>
                  <td>Rating</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.crisil_rating || 'Not Rated'} Stars</td>
                  ))}
                </tr>
                <tr>
                  <td>Category / Sub-category</td>
                  {funds.map((fund, index) => (
                    <td key={index}>
                      {fund.product?.category_name}, {fund.product?.p_category_name}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>Fund Age</td>
                  {funds.map((fund, index) => (
                    <td key={index}>
                      {(
                        fund.product?.launch_date && ( <span>
                          {new Date().getFullYear() - new Date(fund.product?.launch_date).getFullYear()} Years
                          </span>
                        )
                      )}
                      {(
                        !fund.product?.launch_date && ( <span>-</span>)
                      )}                    
                    </td>
                  ))}
                </tr>
              </>

              <>
                <tr>
                  <td><b>Returns</b></td>
                </tr>
                <tr>
                  <td>1 Year</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.returns_1yr || 'N/A'}%</td>
                  ))}
                </tr>
                <tr>
                  <td>3 Year</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.returns_3yr || 'N/A'}%</td>
                  ))}
                </tr>
                <tr>
                  <td>5 Year</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.returns_5yr || 'N/A'}%</td>
                  ))}
                </tr>
              </>

              <>
                <tr>
                  <td><b>Risk Measure</b></td>
                </tr>
                <tr>
                  <td>Standard Deviation</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.risk_meter_scheme || 'N/A'}</td>
                  ))}
                </tr>
                <tr>
                  <td>Sharpe Ratio</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.sharpe_ratio || 'N/A'}</td>
                  ))}
                </tr>
                <tr>
                  <td>Beta</td>
                  {funds.map((fund, index) => (
                    <td key={index}>{fund.product?.beta || 'N/A'}</td>
                  ))}
                </tr>
              </>

              <>
                <tr>
                  <td><b>Portfolio</b></td>
                </tr>
                <tr>
                  <td>Top Sectors</td>
                  {funds.map((fund, index) => {
                    // Group and sum up sectors by `cat`
                    const sectorGroups = fund.summary_data.reduce((acc, sector) => {
                      acc[sector.cat] = (acc[sector.cat] || 0) + parseFloat(sector.per);
                      return acc;
                    }, {});

                    // Convert grouped sectors into an array, sort, and take top 5
                    const topSectors = Object.entries(sectorGroups)
                      .map(([cat, per]) => ({ cat, per }))
                      .sort((a, b) => b.per - a.per)
                      .slice(0, 5);

                    return (
                      <td key={index}>
                        {topSectors.map((sector, i) => (
                          <div key={i}>{sector.cat} ({sector.per.toFixed(2)}%)</div>
                        ))}
                      </td>
                    );
                  })}
                </tr>

                <tr>
                  <td>Top Holdings</td>
                  {funds.map((fund, index) => (
                    <td key={index}>
                      {fund.summary_data
                        ?.sort((a, b) => b.per - a.per)  // Sort by percentage
                        .slice(0, 5)                      // Take top 5 holdings
                        .map((holding, i) => (
                          <div key={i}>{holding.name} ({parseFloat(holding.per).toFixed(2)}%)</div>
                        ))}
                    </td>
                  ))}
                </tr>
              </>
            </tbody>



          </table>
        </div>
      </div>
    </div>
  );
}
